import CenteredLayoutTemplate from "@genstackio/react-admin-ui/lib/templates/layouts/CenteredLayoutTemplate";
import ForgotPasswordForm from "@genstackio/react-admin-ui/lib/molecules/forms/ForgotPasswordForm";

export function ForgotPasswordScreen() {

    return <CenteredLayoutTemplate><ForgotPasswordForm /></CenteredLayoutTemplate>
}

export default ForgotPasswordScreen